import { Routes } from '@angular/router';
import { DashboardComponent } from '../../../pages/dashboard/dashboard.component';
import { NotFoundComponent } from '../../../shared/components/not-found/not-found.component';
import { pageMap } from '../mapping/page-mapping';
import { ProjectComponent } from '../../../pages/project/project.component';
import { ClientComponent } from '../../../pages/client/client.component';
import { CreateEditClientComponent } from '../../../pages/client/create-edit-client/create-edit-client.component';
import { ShiveRoutes } from '../segments/route-segments';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { SettingsComponent } from '../../../pages/settings/settings.component';
import { TimeOffComponent } from '../../../pages/settings/time-off/time-off.component';
import { PendingChangesGuard } from '../../guards/pending-changes.guard';
import { TeamComponent } from '../../../pages/team/team.component';
import { ProjectRoutes } from './project.routes';
import { UserProfileComponent } from '../../../pages/user/user-profile/user-profile.component';
import { PageKey } from '../page-keys';
import { UserProfileRoutes } from './user-profile.routes';
import { userResolver } from '../../resolver/user/user.resolver';
import { TeamRoutes } from './team.routes';
import { ReportsComponent } from '../../../pages/reports/reports.component';
import { ReportRoutes } from './report.routes';
import { FinanceComponent } from '../../../pages/finances/finance.component';
import { FinanceRoutes } from './finance.routes';
import { ClientListComponent } from '../../../pages/client/client-list/client-list.component';
import { TimeTrackingComponent } from '../../../pages/time-tracking/time-tracking.component';
import { TimeTrackingRoutes } from './time-tracking.routes';
import { MyTodosComponent } from '../../../pages/my-todos/my-todos.component';

export const AdminLayoutRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: pageMap.getRoute(PageKey.DashboardPageKeys.Dashboard),
    component: DashboardComponent,
  },
  {
    path: pageMap.getRoute(PageKey.TimeTrackingPageKeys.TimeTracking),
    component: TimeTrackingComponent,
    children: TimeTrackingRoutes,
    resolve: {
      user: userResolver,
    },
  },
  {
    path: pageMap.getRoute(PageKey.ProjectPageKeys.Projects),
    component: ProjectComponent,
    children: ProjectRoutes,
  },
  {
    path: pageMap.getRoute(PageKey.ClientPageKeys.Clients),
    component: ClientComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ShiveRoutes.ClientList,
      },
      {
        path: ShiveRoutes.Overview,
        component: ClientListComponent,
      },
      {
        path: ShiveRoutes.Create,
        component: CreateEditClientComponent,
      },
      {
        path: `${ShiveRoutes.Edit + UrlSegmentDelimiter}:id`,
        component: CreateEditClientComponent,
      },
    ],
  },
  {
    path: pageMap.getRoute(PageKey.TeamPageKeys.Team),
    component: TeamComponent,
    children: TeamRoutes,
  },
  {
    path: pageMap.getRoute(PageKey.FinancePageKeys.Finances),
    component: FinanceComponent,
    children: FinanceRoutes,
  },
  {
    path: pageMap.getRoute(PageKey.UserProfilePageKeys.UserProfile),
    component: UserProfileComponent,
    children: UserProfileRoutes,
    resolve: {
      user: userResolver,
    },
  },
  {
    path: pageMap.getRoute(PageKey.ReportsPageKeys.Reports),
    component: ReportsComponent,
    children: ReportRoutes,
  },
  {
    path: pageMap.getRoute(PageKey.TodoPlannerPageKeys.TodoPlanner),
    component: MyTodosComponent,
  },
  {
    path: pageMap.getRoute(PageKey.SettingsPageKeys.Settings),
    component: SettingsComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ShiveRoutes.SettingsNonworkingTime,
      },
      {
        path: ShiveRoutes.TimeOff,
        component: TimeOffComponent,
        canDeactivate: [PendingChangesGuard],
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
